import { Col, Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { GlobalFilter } from "../shared/Grid/GlobalFilterTemplate";
import RefreshLoadingButton from "../shared/RefreshLoadingButton";
import React from "react";
import { useTranslation } from "react-i18next";

interface UserListHeaderToolbarProps {
  onAddUserClick?: () => void;
  loading: boolean;
  onDataRefreshClick: () => void;
  onGlobalFilter: (value: string) => void;
}

export function UserListHeaderToolbar(props: UserListHeaderToolbarProps) {
  const { t } = useTranslation();

  function handleGlobalFilterInput(event: React.FormEvent<HTMLInputElement>): void {
    const element = event.target as HTMLInputElement;
    props.onGlobalFilter(element.value);
  }

  return (
    <Row>
      <Col>
        <Button
          variant="contained"
          color="primary"
          onClick={props.onAddUserClick}
          startIcon={<FontAwesomeIcon style={{ cursor: "pointer" }} icon={faPlus} />}
        >
          {t("userManagement.userManagementAddNewUser")}
        </Button>
      </Col>
      <Col className="d-flex justify-content-center">
        <GlobalFilter onInput={handleGlobalFilterInput} />
      </Col>
      <Col className="d-flex justify-content-end">
        <RefreshLoadingButton isLoading={props.loading} onClick={props.onDataRefreshClick} />
      </Col>
    </Row>
  );
}
